export const PENDING = "PENDING";
export const PREPARING = "PREPARING";
export const DELIVERING = "DELIVERING";
export const CANCELED = "CANCELED";
export const DONE = "DONE";
